import {
  createAsyncAction,
  createAsyncTypes,
} from 'lib/reduxUtils';

// Async actions
export const FETCH_CCA_RESULTS = createAsyncTypes('ccaResults/fetchCCAResults');
export const fetchCCAResults = createAsyncAction(FETCH_CCA_RESULTS);
